import axios from 'axios';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/* eslint-disable compat/compat */
var defaultConfig = {
  rootMargin: '0px 0px 0px 0px',
  threshold: [0, 0.5, 1]
};
class ElementIntersectionObserver {
  constructor(elements, onChange, config) {
    this.intersections = void 0;
    this.elements = void 0;
    this.elements = elements.slice(0);
    this.intersections = elements.map(target => ({
      target,
      isIntersecting: false,
      ratio: null
    }));
    this.intersectionObserver = new IntersectionObserver(entries => {
      var intersections = this.intersections.slice(0);
      entries.forEach(entry => {
        var idx = elements.indexOf(entry.target);
        intersections.splice(idx, 1, {
          target: entry.target,
          isIntersecting: entry.isIntersecting,
          ratio: entry.intersectionRatio
        });
      });
      this.intersections = intersections;
      onChange(this.intersections);
    }, _objectSpread2({}, defaultConfig, {}, config));
    elements.forEach(elm => this.intersectionObserver.observe(elm));
  }

  disconnect() {
    // Unregister trigger elements
    this.elements.forEach(elm => this.intersectionObserver.unobserve(elm)); // Disconnect intersection observer

    this.intersectionObserver.disconnect();
  }

}

function toggleAttribute(el, name, boolValue) {
  if (!el) {
    return;
  }

  var nextValue;

  if (typeof boolValue !== 'undefined') {
    nextValue = !!boolValue;
  } else {
    nextValue = el.hasAttribute(name);
  }

  if (nextValue) {
    el.setAttribute(name, '');
  } else {
    el.removeAttribute(name);
  }
}
function setAttribute(el, name, nextValue) {
  if (!el) {
    return;
  }

  if (nextValue) {
    el.setAttribute(name, nextValue);
  } else {
    el.removeAttribute(name);
  }
}
var closest = (() => {
  var proto = typeof window === 'undefined' ? {} : window.Element.prototype;
  var match = proto.matches || proto.msMatchesSelector || proto.webkitMatchesSelector;

  if (proto.closest) {
    return (el, css) => el.closest(css);
  } else {
    return (el, css) => {
      for (; el; el = el.parentElement) {
        if (match.call(el, css)) return el;
      }

      return null;
    };
  }
})();
function addStyle(nodeName, css) {
  var key = "style-".concat(nodeName.toLowerCase());
  var min = css.replace(/\/\*[^!][^*]*\*\//g, '').replace(/\s*(^|[:;,{}]|$)\s*/g, '$1');
  document.getElementById(key) || document.head.insertAdjacentHTML('afterbegin', "<style id=\"".concat(key, "\">").concat(min, "</style>"));
}
function toArray(nodeList) {
  return [].slice.call(nodeList);
}
function dispatchEvent(element, name) {
  var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var ignore = "prevent_recursive_dispatch_maximum_callstack".concat(name);
  var event;
  if (element[ignore]) return true; // We are already processing this event, so skip sending a new one
  else element[ignore] = true; // Add name to dispatching ignore

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(name, {
      bubbles: true,
      cancelable: true,
      detail
    });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(name, true, true, detail);
  } // IE reports incorrect event.defaultPrevented
  // but correct return value on element.dispatchEvent


  var result = element.dispatchEvent(event);
  element[ignore] = null; // Remove name from dispatching ignore

  return result; // Follow W3C standard for return value
}

function easeOutQuint(t) {
  return 1 + --t * t * t * t * t;
}

class VerticalScroll {
  constructor(container) {
    this.container = void 0;
    this.container = container;
  }

  to(top) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var from = this.container.scrollTop;
    var distance = top - from;
    var startTime = null;

    var loop = currentTime => {
      if (!startTime) {
        startTime = currentTime - 1;
      }

      var timeElapsed = currentTime - startTime;
      this.container.scrollTop = from + distance * easeOutQuint(timeElapsed / duration);

      if (timeElapsed < duration) {
        window.requestAnimationFrame(loop);
      } else {
        this.container.scrollTop = top;
      }
    };

    window.requestAnimationFrame(loop);
  }

}
class HorizontalScroll {
  constructor(container) {
    this.container = void 0;
    this.container = container;
  }

  to(left) {
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    var callback = arguments.length > 2 ? arguments[2] : undefined;
    var from = this.container.scrollLeft;
    var distance = left - from;
    var startTime = null;

    var loop = currentTime => {
      if (!startTime) {
        startTime = currentTime - 1;
      }

      var timeElapsed = currentTime - startTime;
      this.container.scrollLeft = from + distance * easeOutQuint(timeElapsed / duration);

      if (timeElapsed < duration) {
        window.requestAnimationFrame(loop);
      } else {
        this.container.scrollLeft = left;
        callback && callback();
      }
    };

    window.requestAnimationFrame(loop);
  }

}

function testReducedMotion() {
  if (typeof window !== 'undefined') {
    return !!window.matchMedia && window.matchMedia('(prefers-reduced-motion)').matches;
  }

  return false;
}

var name = process.env.npm_package_name;
var version = process.env.npm_package_version;

function createGqlApi() {
  return {
    get(query, url) {
      return _asyncToGenerator(function* () {
        var {
          data,
          errors
        } = yield axios({
          method: 'POST',
          url,
          data: {
            query,
            variables: null
          },
          timeout: 7500,
          headers: {
            'User-Agent': "".concat(name, "/").concat(version, " (node/isomorphic-fetch)"),
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }
        }).then(res => res.data);

        if (errors && errors.length) {
          throw Error(errors);
        }

        return transformResponse(data);
      })();
    }

  };
}

var gqlApi = createGqlApi();

function pngFragment(options) {
  var aspects = options.aspectRatios.map(ratio => {
    var sizes = ratio.sizes.map(s => "w".concat(s, ": url(quality: ").concat(ratio.quality || '0.7', ", width: ").concat(s, ", format: png)")).join('\n');
    return "".concat(ratio.id, ": crop(aspect: ").concat(ratio.id, ") {\n        ").concat(ratio.id === 'original' ? 'aspect' : '', "\n        ").concat(sizes, "\n      }");
  }).join('\n');
  return "\nfragment imageCropsPng on Image {\n  title,\n  creators,\n  credit,\n  category,\n  ".concat(aspects, "\n}\n");
}

function jpgFragment(options) {
  var aspects = options.aspectRatios.map(ratio => {
    var sizes = ratio.sizes.map(size => "w".concat(size, ": url(quality: ").concat(ratio.quality || '0.7', ", width: ").concat(size, ")")).join('\n');
    return "".concat(ratio.id, ": crop(aspect: ").concat(ratio.id, ") {\n        ").concat(ratio.id === 'original' ? 'aspect' : '', "\n        ").concat(sizes, "\n      }");
  }).join('\n');
  return "\nfragment imageCropsJpg on Image {\n  title,\n  creators,\n  credit,\n  category,\n  ".concat(aspects, "\n}\n");
}
/**
 * Transforms a series of image sections to a Polopoly GraphQL API query
 */


function createQuery(imageObjects, options) {
  var images = getImageIds(imageObjects);
  return "\n    ".concat(createBase(images, options), "\n    query {\n      ").concat(images.map(getImage).join('\n'), "\n    }");
}
var IMAGE_PROPS = ['vertical', 'horizontal'];

function getImageIds(imageObjects) {
  if (imageObjects.some(image => !image)) {
    throw new Error('Undefined image object');
  }

  return imageObjects.reduce((result, image) => {
    var format = image.advanced && image.advanced.format || 'jpg';
    /* Image can be stored directly on image object */

    if (image.id && !result.find(el => el.id === image.id)) {
      result.push({
        id: image.id,
        format
      });
    }
    /* or on a predefined set of image properties */


    IMAGE_PROPS.forEach(prop => {
      var value = image[prop];

      if (value && value.id && !result.find(el => el.id === value.id)) {
        result.push({
          id: value.id,
          format
        });
      }
    });
    return result;
  }, []);
}

function getImage(_ref) {
  var {
    id,
    format = 'jpg'
  } = _ref;

  if (format === 'png') {
    return "".concat(transformId(id), ": model(id: \"").concat(id, "\") {\n      ...imageCropsPng\n    }");
  }

  return "".concat(transformId(id), ": model(id: \"").concat(id, "\") {\n    ...imageCropsJpg\n  }");
}

function createBase(imageObjects, options) {
  var containsJpg = imageObjects.filter(el => el.format === 'jpg').length > 0;
  var containsPng = imageObjects.filter(el => el.format === 'png').length > 0;
  return "\n    ".concat(containsJpg ? jpgFragment(options) : '', "\n    ").concat(containsPng ? pngFragment(options) : '', "\n  ");
}
/**
 * Transforns a polopoly id to something that can be used as a key in a GraphQL query
 * Example: '1.14252981' -> 'id_1_14252981'
 */


function transformId(id) {
  return "id".concat(id.replace(/\./g, '__'));
}
/**
 * Transforns an already transformed polopoly id back to a regular polopoly id
 * Example: ''id_1_14252981' -> 1.14252981'
 */


function transformBackId(id) {
  return id.replace('id', '').replace(/__/g, '.');
}

function transformResponse(response) {
  return Object.keys(response).reduce((res, key) => {
    var transformedKey = transformBackId(key);
    res[transformedKey] = response[key];
    return res;
  }, {});
}

function fromEntries(items) {
  return [...items].reduce((obj, _ref) => {
    var [key, val] = _ref;
    obj[key] = val;
    return obj;
  }, {});
}

function traverse(obj, filter) {
  if (filter(obj)) {
    /* Object is a match, returning */
    return [obj];
  } else {
    return Object.entries(obj).filter((_ref2) => {
      var [_, value] = _ref2;
      return !!value;
    }).map((_ref3) => {
      var [_, value] = _ref3;

      if (Array.isArray(value)) {
        return value.map(item => traverse(item, filter)).reduce((acc, val) => acc.concat(val), []);
      } else if (typeof value === 'object') {
        return traverse(value, filter);
      } else {
        return null;
      }
    }).reduce((acc, val) => acc.concat(val), []).filter(Boolean);
  }
}
/*
 * Traverses the props tree and fetches data for all image objects
 * */


function prefetchImageData(_x, _x2) {
  return _prefetchImageData.apply(this, arguments);
}

function _prefetchImageData() {
  _prefetchImageData = _asyncToGenerator(function* (props, options) {
    var imageObjects = traverse(props, value => value.type === 'image');

    if (imageObjects.length > 0) {
      if (!options.gqlApiUrl) {
        throw new Error("Missing option 'gqlApiUrl'");
      }

      var query = createQuery(imageObjects, options);
      return gqlApi.get(query, options.gqlApiUrl);
    }
  });
  return _prefetchImageData.apply(this, arguments);
}

var imageProps = ['vertical', 'horizontal'];
function mergeImageProps(props, imageUrls) {
  if ('id' in props) {
    return _objectSpread2({}, props, {}, imageUrls[props.id]);
  } else {
    return fromEntries(Object.entries(props).map((_ref4) => {
      var [key, value] = _ref4;

      if (imageProps.indexOf(key) !== -1) {
        return [key, mergeImageProps(value, imageUrls)];
      } else {
        return [key, value];
      }
    }));
  }
}

function mergeVideoloopProps(_x) {
  return _mergeVideoloopProps.apply(this, arguments);
}

function _mergeVideoloopProps() {
  _mergeVideoloopProps = _asyncToGenerator(function* (props) {
    var objects = yield Promise.all(Object.keys(props).map(
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(function* (key) {
        if (key === 'horizontal' || key === 'vertical') {
          return _objectSpread2({
            id: key
          }, props[key], {
            videos: yield getVideoSrc(props[key])
          });
        }
      });

      return function (_x4) {
        return _ref2.apply(this, arguments);
      };
    }()));
    return _objectSpread2({}, props, {}, objects.filter(Boolean).reduce((accumulator, current) => {
      accumulator[current.id] = current;
      delete accumulator[current.id].id;
      return accumulator;
    }, {}));
  });
  return _mergeVideoloopProps.apply(this, arguments);
}

function getVideoSrc(_x2) {
  return _getVideoSrc.apply(this, arguments);
}

function _getVideoSrc() {
  _getVideoSrc = _asyncToGenerator(function* (videoObj) {
    var hasVideoUrl = videoObj && videoObj !== 'null';

    if (hasVideoUrl) {
      var videos = yield getVideos(videoObj.url);
      var basePath = extractBasePathFromUrl(videoObj.url);
      return videos.map(video => ({
        type: getTypeFromHeight(video.height),
        poster: "".concat(basePath, "/").concat(video.stillFileName),
        aspectRatio: video.displayAspectRatio,
        height: video.height,
        sources: {
          mp4: "".concat(basePath, "/").concat(video.videoFileName)
        }
      }));
    } else {
      return null;
    }
  });
  return _getVideoSrc.apply(this, arguments);
}

function extractBasePathFromUrl(url) {
  var decodedUrl = url.replace(/%2F/g, '/');
  return decodedUrl.substr(0, decodedUrl.lastIndexOf('/'));
}

function getVideos(_x3) {
  return _getVideos.apply(this, arguments);
}

function _getVideos() {
  _getVideos = _asyncToGenerator(function* (url) {
    var videoPayload = yield getVideoPayload(url);
    return videoPayload.movingStills;
  });
  return _getVideos.apply(this, arguments);
}

function getVideoPayload(url) {
  return axios.get(url, {
    timeout: 2000
  }).then((_ref) => {
    var {
      data
    } = _ref;
    return data;
  });
}

function getTypeFromHeight(height) {
  switch (height) {
    case 360:
      return 'small';

    case 720:
      return 'medium';

    case 1080:
      return 'large';

    default:
      return 'large';
  }
}

function mergeMapProps(_x) {
  return _mergeMapProps.apply(this, arguments);
}

function _mergeMapProps() {
  _mergeMapProps = _asyncToGenerator(function* (props) {
    var {
      id
    } = props,
        rest = _objectWithoutProperties(props, ["id"]);

    return _objectSpread2({
      id
    }, rest, {
      definition: yield getMapDefinition(id)
    });
  });
  return _mergeMapProps.apply(this, arguments);
}

function getMapDefinition(_x2) {
  return _getMapDefinition.apply(this, arguments);
}

function _getMapDefinition() {
  _getMapDefinition = _asyncToGenerator(function* (id) {
    if (!id) {
      return;
    }

    return axios.get("https://dh.nrk.no/atlas/v1/definition?id=".concat(id), {
      timeout: 2000
    }).then((_ref) => {
      var {
        data
      } = _ref;
      return data;
    });
  });
  return _getMapDefinition.apply(this, arguments);
}

function fromEntries$1(items) {
  return [...items].reduce((obj, _ref) => {
    var [key, val] = _ref;
    obj[key] = val;
    return obj;
  }, {});
}

var defaultOptions = {
  image: {
    gqlApiUrl: 'https://www.nrk.no/api/graphql',
    aspectRatios: [{
      id: 'F11',
      sizes: ['450', '768', '1280']
    }, {
      id: 'F34',
      sizes: ['450', '768', '1280']
    }, {
      id: 'F169',
      sizes: ['900', '1280', '2400']
    }, {
      id: 'original',
      sizes: ['450', '768', '1280', '2400']
    }]
  }
};
function mergeMediaProps(_x, _x2, _x3) {
  return _mergeMediaProps.apply(this, arguments);
}

function _mergeMediaProps() {
  _mergeMediaProps = _asyncToGenerator(function* (props, options, imageData) {
    var mergedOptions = {
      image: _objectSpread2({}, defaultOptions.image, {}, options === null || options === void 0 ? void 0 : options.image)
    };
    var imageDataStored = imageData || (yield prefetchImageData(props, mergedOptions.image));

    if (props.type === 'videoloop') {
      return mergeVideoloopProps(props);
    } else if (props.type === 'image') {
      return mergeImageProps(props, imageDataStored);
    } else if (props.type === 'map') {
      return mergeMapProps(props, imageDataStored);
    } else {
      var mappedEntries = yield Promise.all(Object.entries(props).map(
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(function* (_ref2) {
          var [key, value] = _ref2;

          if (Array.isArray(value)) {
            var mergedArray = yield Promise.all(value.map(item => mergeMediaProps(item, options, imageDataStored)));
            return [key, mergedArray];
          } else if (typeof value === 'object' && value !== null) {
            return [key, yield mergeMediaProps(value, options, imageDataStored)];
          } else {
            return [key, value];
          }
        });

        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }()));
      return fromEntries$1(mappedEntries);
    }
  });
  return _mergeMediaProps.apply(this, arguments);
}

var MAX_SAFE_INTEGER = 9007199254740991;
function withinRange(current) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var stop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_SAFE_INTEGER;
  return current >= start && current <= stop;
}

export { ElementIntersectionObserver, HorizontalScroll, VerticalScroll, addStyle, closest, dispatchEvent, mergeImageProps, mergeMapProps, mergeMediaProps, mergeVideoloopProps, setAttribute, testReducedMotion, toArray, toggleAttribute, withinRange };
//# sourceMappingURL=dh-basis-common.esm.js.map



// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-basis-common/dh-basis-common.esm.js